import {Component, Input, OnInit} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {V3ExerciseSessionQuestionBase, V3Images} from "../../../model/v3/cspa";

class AnswerMap {
  img: string
  studentAnswer: string
  correctAnswer: string
  constructor(img: string, studentAnswer: string, correctAnswer: string) {
    this.img = img;
    this.studentAnswer = studentAnswer;
    this.correctAnswer = correctAnswer;
  }
}

@Component({
    selector: 'app-pictures-result',
    templateUrl: './pictures-result.component.html',
    styleUrls: ['./pictures-result.component.scss'],
    standalone: false
})
export class PicturesResultComponent implements OnInit {
  @Input() questions: V3ExerciseSessionQuestionBase<V3Images>[]

  questionAnswerMap: AnswerMap[] = []
  constructor() { }

  ngOnInit(): void {
    this.questions.forEach(q => {
      q.questionDef.answerDef.answers.forEach(a => {
        let img = a.val[0]
        let correctAnswer = a.name
        let studentAnswer = q.questionDef.answerDef.answerHolder?.answers?.find(an => an.val[0] == img)?.name || "-"
        this.questionAnswerMap.push(new AnswerMap(img, studentAnswer, correctAnswer))
      })
    })
  }

  isAnswerIncorrect(q: AnswerMap) {
    return q.studentAnswer == q.correctAnswer
  }

  getImgSource(img: string) {
    return environment.awsBase + img
  }
}
